/**
 * Hibrid - különleges eljárással készülő   * WHEAT_BEER - Búzasör (Weizen/Weissbier/Wheat)   * WIT_WHITE - Wit/White   * ALT_ALTBIER - Alt/Altbier   * KOELSCH - Kölsch   * STEAM_BEER - Gőzsör (Steam Beer/Dampfbier)   * SMOKED_BEER - Füstölt sör (smoked beer/Rauchbier)   * SEASONAL_WINTER_CHRISTMAS_BEERS - Seasonal/Winter/Christmas Beers
 */
export type Hybrid =
  | 'WHEAT_BEER'
  | 'WIT_WHITE'
  | 'ALT_ALTBIER'
  | 'KOELSCH'
  | 'STEAM_BEER'
  | 'SMOKED_BEER'
  | 'SEASONAL_WINTER_CHRISTMAS_BEERS';

export const Hybrid = {
  WheatBeer: 'WHEAT_BEER' as Hybrid,
  WitWhite: 'WIT_WHITE' as Hybrid,
  AltAltbier: 'ALT_ALTBIER' as Hybrid,
  Koelsch: 'KOELSCH' as Hybrid,
  SteamBeer: 'STEAM_BEER' as Hybrid,
  SmokedBeer: 'SMOKED_BEER' as Hybrid,
  SeasonalWinterChristmasBeers: 'SEASONAL_WINTER_CHRISTMAS_BEERS' as Hybrid,
};
